export const PANEL_PREFIX = 'react/panels/';
export interface Panel {
    version: 1;
    id: string;
    name: string;
    stationNames: string[];
    locoIds: string[];
    updatedAt: string;
}

export const validPanelId = (id: string) => /^[a-zA-Z0-9_-]{1,80}$/.test(id);
export const validStationName = (name: string) =>
    name.length > 0 &&
    name.length <= 80 &&
    name === name.trim() &&
    !/[\u0000-\u001f\u007f/+#]/.test(name);
export const panelPath = (id: string) => `/panel/${encodeURIComponent(id)}`;

export function validatePanel(value: unknown): value is Panel {
    if (!value || typeof value !== 'object') return false;
    const panel = value as Panel;
    return (
        panel.version === 1 &&
        typeof panel.id === 'string' &&
        validPanelId(panel.id) &&
        typeof panel.name === 'string' &&
        panel.name.trim().length > 0 &&
        panel.name.length <= 80 &&
        Array.isArray(panel.stationNames) &&
        panel.stationNames.length <= 100 &&
        panel.stationNames.every((name) => typeof name === 'string' && validStationName(name)) &&
        new Set(panel.stationNames).size === panel.stationNames.length &&
        Array.isArray(panel.locoIds) &&
        panel.locoIds.length <= 100 &&
        panel.locoIds.every((id) => typeof id === 'string' && /^\d{2,6}$/.test(id)) &&
        new Set(panel.locoIds).size === panel.locoIds.length &&
        panel.stationNames.length + panel.locoIds.length > 0 &&
        typeof panel.updatedAt === 'string' &&
        Number.isFinite(Date.parse(panel.updatedAt))
    );
}

export function parsePanel(id: string, payload: string): Panel | null {
    if (payload.length > 32768) return null;
    try {
        const panel: unknown = JSON.parse(payload);
        return validatePanel(panel) && panel.id === id ? panel : null;
    } catch {
        return null;
    }
}
